const OQModXSiteApi = {
  update_cart_item: (cart_item_id, cart_item) => {
    const cart = JSON.parse(localStorage.globalCart || "{}");
    cart[cart_item_id] = {
      ...cart_item,
      url: cart_item.url + "?cartItemId=" + cart_item_id,
    };
    localStorage.setItem("globalCart", JSON.stringify(cart));
  },
  add_cart_item: (cart_item) => {
    // TODO: create as api method
    const cart = JSON.parse(localStorage.globalCart || "{}");
    const cart_item_id =
      cart_item.type +
      "__" +
      (Object.keys(cart).filter(
        (c) => cart[c] && cart[c].type === cart_item.type
      ).length +
        1);

    cart[cart_item_id] = {
      ...cart_item,
      url: cart_item.url + "?cartItemId=" + cart_item_id,
    };
    localStorage.setItem("globalCart", JSON.stringify(cart));
    return cart_item_id;
  },
};

export default OQModXSiteApi;
